'use client';

import Script from 'next/script';

import { WindowWithInterfaces } from '@/typings/window';

type Props = { src: string; styleHref: string };

// Rendered only for articles that contain code (see ArticleContent). The theme stylesheet only styles
// the `.hljs-*` classes highlight.js adds, so it is attached here right before highlightAll() instead
// of as a <head> <link>, where it blocked rendering of every article (~850 ms, Lighthouse mobile).
// next/script's onLoad is a function, so this has to be a client island.
export const HighlightJs = ({ src, styleHref }: Props) => (
  <Script
    src={src}
    onLoad={() => {
      if (!document.querySelector(`link[href="${styleHref}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = styleHref;
        document.head.appendChild(link);
      }
      (window as WindowWithInterfaces).hljs.highlightAll();
    }}
  />
);
